export default __webpack_public_path__ + "static/media/5.c012254a.jpg";